export default {
  launcherAnimSpeed: 0.2,
  messageDelay: 0.4,
  messageDelaySlow: 1.2,

  formsDuration: 0.4,
  formsScrollDuration: 1,
  formsDelay: 0.2,
  formsDelayFirstRun: 0.2,

  messageDelayFirstRun: 0.3,
  messageDuration: 0.3,
  messageUserDistance: 20,
  messageSystemDistance: 20,
}
